/**
 * "Upload SOW / Execution Plan" for a known team (SAD-898). Always sends
 * document_kind=sow with that team's workstreamId — no team picker. Uses
 * FileUploader (shared with Docs) so Specra conformance stays clean. Review
 * items land on Modifications / ContractIntake.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Upload } from 'lucide-react';
import { useState } from 'react';
import { FileUploader } from '../../../components/ProjectList/FileUploader';
import { useProgram } from '../Programs/hooks';
import { useProgramWriteAccess } from '../Programs/programWriteAccess';
import { useUploadSowDocument } from './useUploadSowDocument';
export function UploadSowButton({ programId, workstreamId, inputTestId = Testids.cmWorkstream.sowUploadInput, buttonTestId = Testids.cmWorkstream.sowUpload }) {
    const { data, isLoading } = useProgram(programId);
    const zouProjectId = data?.program?.zouProjectId ?? '';
    const canEdit = useProgramWriteAccess(programId).contractDocuments;
    const upload = useUploadSowDocument();
    const [open, setOpen] = useState(false);
    const [files, setFiles] = useState([]);
    if (isLoading || !zouProjectId) return null;
    const busy = upload.isPending;
    const onFiles = async (next)=>{
        const one = next.slice(-1);
        setFiles(one);
        const file = one[0];
        if (!file || !canEdit) return;
        try {
            await upload.mutateAsync({
                programId,
                zouProjectId,
                workstreamId,
                file
            });
            setFiles([]);
            setOpen(false);
        } catch  {
        // toast already surfaced in the hook
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex shrink-0 flex-col items-end gap-2",
        children: [
            /*#__PURE__*/ _jsxs(SpecraButton, {
                size: "sm",
                disabled: busy || !canEdit,
                onClick: ()=>setOpen((v)=>!v),
                "data-testid": buttonTestId,
                children: [
                    /*#__PURE__*/ _jsx(Upload, {
                        className: "mr-1.5 h-3.5 w-3.5"
                    }),
                    busy ? 'Uploading…' : 'Upload SOW / Execution Plan'
                ]
            }),
            !canEdit ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "caption",
                tone: "muted",
                children: "You do not have permission to upload a SOW for this team."
            }) : null,
            open && canEdit ? /*#__PURE__*/ _jsx("div", {
                className: "w-80",
                children: /*#__PURE__*/ _jsx(FileUploader, {
                    files: files,
                    onChange: onFiles,
                    disabled: busy,
                    inputTestid: inputTestId
                })
            }) : null
        ]
    });
}
